"use client";

import posthog from "posthog-js";

/**
 * The browser's PostHog id, sent on onboarding session mint so server-side fact
 * analytics land on this visitor's person (ADR 056). Undefined when PostHog is
 * not initialized or blocked — the server then falls back to an anonymous id,
 * and the mint never depends on it.
 */
export function currentPosthogDistinctId(): string | undefined {
  try {
    return posthog.get_distinct_id?.() ?? undefined;
  } catch {
    // benign: PostHog not initialized or blocked; the mint proceeds without it.
    return undefined;
  }
}
